<template>

<div id="slide08" class="section section-dark">

  <Subtitle :text="$t('home.slide08.title')"/>

  <div id="slide08-text" class="half-block half-block-1">

    <Common :text="$t('home.slide08.text1')"/>

    <div class="no-first-paragraph">
      <Common :text="$t('home.slide08.text2')"/>
    </div>

  </div>

  <div id="mc_embed_signup" class="half-block half-block-2">

    <Form
      id="mc-embedded-subscribe-form"
      name="mc-embedded-subscribe-form"
      action="https://quantifiedreading.us20.list-manage.com/subscribe/post?u=cf87a768c977a161c3ec17e94&amp;id=79064e04e6"
      method="post"
      :items="[
        { formType: 'input', id: 'mce-NAME', name: 'NAME', type: 'text', required: true, placeholder: 'home.slide08.form.name' },
        { formType: 'input', id: 'mce-EMAIL', name: 'EMAIL', type: 'email', required: true, placeholder: 'home.slide08.form.email' },
        { formType: 'input', id: 'mce-group[6130]-6130-0', name: 'group[6130][1]', type: 'checkbox', value: 1, required: true, label: 'home.slide08.form.storage' },
        { formType: 'input', id: 'mce-group[6134]-6134-0', name: 'group[6134][2]', type: 'checkbox', value: 1, required: true, label: 'home.slide08.form.marketing' },
        { formType: 'notification', type: 'error', id: 'mce-error-response' },
        { formType: 'notification', type: 'success', id: 'mce-success-response' },
        { formType: 'submit', text: 'home.slide08.form.submit' }
      ]"/>

  </div>

</div>

</template>

<script>
import Subtitle from '../general/texts/Subtitle.vue'
import Common from '../general/texts/Common.vue'
import Form from '../general/forms/Form.vue'

export default {
  name: 'Slide08',
  components: {
    Subtitle,
    Common,
    Form
  }
}
</script>

<style lang="scss" scoped>
.no-first-paragraph {
  margin-top: 15px;
}

@media (min-width: 1500px), (min-device-width: 1500px) {
  .half-block-2 {
    width: 30%;
    margin-left: 20%;
  }
}
</style>
